<template>
    <div>

        <v-alert v-if="items.length===0" color="info" class="body-2 ma-3 mt-6" icon="mdi-information">
            No notifications found.
        </v-alert>

        <div class="text-right">
            <v-btn v-show="this.notificationsSorted.length > 5" class="mr-4 mt-4" color="primary" small @click="dismissAllClicked">
                Dismiss all
            </v-btn>
        </div>

        <v-card
            raised
            dark
            v-for="item in notificationsSorted"
            :key="items.id"
            class="ma-3"
            color="grey darken-2"
        >
            <v-card-text class="pb-0">
                <v-alert dense prominent :type="item.level" v-if="item.subject">
                    <v-card-text class="pa-1 body-2">
                        {{ item.subject }}
                    </v-card-text>

                    <div class="pa-1 caption">
                        Received {{ toHumanFrom(item.created_at) }}
                    </div>
                </v-alert>

                <vue-markdown :source="item.body" :show="true">
                </vue-markdown>

            </v-card-text>

            <v-card-actions class="pt-0 pl-2">
                <v-btn v-if="item.action_text" ripple class="ml-2" small @click="goToUrl(item.action_url)" color="primary">
                    {{ item.action_text }}
                </v-btn>
                <v-btn text @click="dismissClicked(item.id)">Dismiss</v-btn>
            </v-card-actions>
        </v-card>

    </div>

</template>

<script>

import VueMarkdown from '@adapttive/vue-markdown';
import {timeDisplay} from '../../../components/mixins/timeDisplayMixin';
import Json from 'vue-json-pretty';
import moment from "moment";

export default {

    mixins: [timeDisplay],

    components: {
        VueMarkdown,
        Json
    },

    props: {
        items: {
            type: Array,
            required: true
        }
    },

    computed: {
        notificationsSorted() {
            return this.$store.state.notifications.sort((a, b) => {
                if (moment(a.created_at).isBefore(moment(b.created_at))) return 1;
                if (moment(a.created_at).isAfter(moment(b.created_at))) return -1;
                return 0;
            });
        },
    },

    data() {
        return {}
    },

    methods: {
        goToUrl(url) {
            this.$router.push(url);
        },
        dismissClicked(id) {
            this.$store.dispatch('markMessagesRead', [id]);
        },
        dismissAllClicked() {
            const ids = this.$store.state.notifications.map(n => n.id);
            this.$store.dispatch('markMessagesRead', ids);
        }
    }
};

</script>
